<template>
  <div class="mb-1 lg:mb-2">
    <!-- LABEL -->
    <div class="flex flex-row justify-between align-middle mb-[0.15rem] lg:mb-1">
      <label :for="fieldId" class="block text-grey-darker text-xs lg:text-sm">
        {{ label }}
        <span v-if="required" class="text-red-500 md:ml-1 xl:ml-2">*</span>
      </label>
    </div>

    <!-- INPUT -->
    <div class="relative text-xs lg:text-sm">
      <input
        :id="fieldId"
        :type="isMonthOnly ? 'month' : 'date'"
        v-model="inputValue"
        :disabled="disabled"
        :min="minDate"
        :max="maxDate"
        @focus="focused = true"
        @blur="handleBlur"
        @change="onChange"
        class="border border-gray-300 rounded-[0.35rem] lg:rounded-[0.5rem] p-2 lg:border-2 xl:p-3 w-full bg-white"
        :class="{
          'text-gray-400': !inputValue,
          'bg-gray-100 cursor-not-allowed': disabled
        }"
      />

    </div>

    <!-- VALIDATION -->
    <p
      v-if="validationMessage"
      class="text-xs xl:text-sm text-red-500 mt-1 xl:mt-2"
    >
      {{ validationMessage }}
    </p>
  </div>
</template>

<script>
export default {
  name: "v-datepicker",
  props: {
    label: String,
    modelValue: String,
    disabled: Boolean,
    fieldId: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: String,
      default: "",
    },
    maxDate: {
      type: String,
      default: "",
    },
    isMonthOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputValue: this.modelValue || "",
      focused: false,
      validationMessage: "",
    };
  },
  watch: {
    modelValue(newVal) {
      this.inputValue = newVal;
    },
  },
  methods: {
    onChange() {
      this.$emit("update:modelValue", this.inputValue);
    },
    handleBlur() {
      this.focused = false;
      this.validateField();
    },
    validateField() {
      let isValid = true;
      this.validationMessage = "";

      if (this.required && !this.inputValue) {
        this.validationMessage = "This field is required.";
        isValid = false;
      }

      this.$emit("validation-status", this.fieldId, isValid);
    },
  },
};
</script>